var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0344 5.71564L11.7844 0.465637C11.6415 0.326345 11.4495 0.248887 11.25 0.250012H2.25C1.85218 0.250012 1.47064 0.408047 1.18934 0.689352C0.908035 0.970656 0.75 1.35219 0.75 1.75001V18.25C0.75 18.6478 0.908035 19.0294 1.18934 19.3107C1.47064 19.592 1.85218 19.75 2.25 19.75H15.75C16.1478 19.75 16.5294 19.592 16.8107 19.3107C17.092 19.0294 17.25 18.6478 17.25 18.25V6.25001C17.2511 6.05048 17.1737 5.85851 17.0344 5.71564ZM12 2.80939L14.6906 5.50001H12V2.80939ZM15.75 18.25H2.25V1.75001H10.5V6.25001C10.5 6.44892 10.579 6.63969 10.7197 6.78034C10.8603 6.92099 11.0511 7.00001 11.25 7.00001H15.75V18.25Z",
    fill: "#18397A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.1480e33537506a2530c4ac3e7be7b3fa.svg";
export { ForwardRef as ReactComponent };